"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {
            zIndex: theme.zIndex.snackbar - 100,
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            overflow: 'hidden',
            backgroundColor: 'rgba(0,0,0,0.85)',
            color: '#fff',
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        },
        content: {
            display: 'flex',
            height: '100%',
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        slideWrapper: {
            height: '50vh',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        slides: {
            display: 'flex',
            minWidth: '500px',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
        },
        slideControl: {
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#fff',
            borderRadius: 3,
            '& .Mui-disabled': {
                color: 'rgba(255,255,255,0.25)',
            },
            '& .MuiIconButton-root': {
                borderRadius: 3,
                height: '100%',
            },
            '& .MuiSvgIcon-fontSizeInherit': {
                fontSize: '64px',
            },
        },
        toolbar: {
            color: '#fff',
            display: 'flex',
            justifyContent: 'flex-end',
        },
        thumbs: {},
    });
});
